<template>
  <div v-if="isAppleRelayEmail" class="applelogin-user-attention">
    <p class="applelogin-user-attention__txt">
      ※ログインしているアカウントのメールアドレスは<span
        style="font-size: 120%"
        >{{ userEmail }}</span
      >です。<br />正常なサービスを利用するためにはメールアドレスの変更が必要です。
    </p>
    <a href="/mypage/basicinfo" class="applelogin-user-attention__btn"
      >メールアドレスの変更はこちら</a
    >
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuth } from '@/composables/useAuth'

const APPLE_PRIVATE_RELAY_DOMAIN = '@privaterelay.appleid.com'

const { user } = useAuth()

const userEmail = computed(() => user.value?.email ?? '')

const isAppleRelayEmail = computed(() =>
  userEmail.value.includes(APPLE_PRIVATE_RELAY_DOMAIN)
)
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables';

.applelogin-user-attention {
  margin: 20px;
  padding: 20px;
  background: #fcc;
  border-radius: 10px;
  color: #e3165c;
  font-weight: bold;
  text-align: center;

  &__txt {
    margin-bottom: 8px;
    overflow-wrap: anywhere;

    @include max-width(sm) {
      text-align: left;
    }
  }

  &__btn {
    background: #fff;
    border: 1px solid #fff;
    padding: 7px 15px;
    border-radius: 20px;
    font-size: 12px;

    &:hover {
      opacity: 1;
      text-decoration: none;
      border: 1px solid #e3165c;
      background: #e3165c;
      color: #fff;
    }
  }
}
</style>
